import React from "react";

function Error() {
  return <h1>Siden finnes ikke :(</h1>;
}

export default Error;
